import { http, uploadFile } from '@/utils/axios'
import axios from 'axios'
import qs from 'qs'

/**
 * @msg: 获取机构列表
 */
export function getinstitutionList() {
  return http({
    url: http.baseUrl('elSchool/getList'),
    method: 'POST',
    params: http.params({

    })
  })
}

/**
 * @msg: 获取课件库列表
 */
export function getList({ uid, institutionId, userType, wareName = '', page = 0, pageSize = 10 }) {
  return http({
    url: http.baseUrl('courseWare/getList'),
    method: 'get',
    params: http.params({
      uid,
      institutionId,
      userType,
      page,
      pageSize,
      wareName
    })
  })
}


/**
 * @msg: 查看课件库
 */
export function viewCourseWare(id) {
  return http({
    url: http.baseUrl('courseWare/viewCourseWare'),
    method: 'get',
    params: http.params({
      id
    })
  })
}



/**
 * @msg: 启禁用/删除课件库
 */
export function updateStatus({ id = '', wareStatus = '', delFlag = '' }) {
  return http({
    url: http.baseUrl('courseWare/updateStatus'),
    method: 'get',
    params: http.params({
      id,
      wareStatus,
      delFlag
    })
  })
}



/**
 * @msg: 查看课程信息
 */
export function viewCourseDetail(id) {
  return http({
    url: http.baseUrl('courseDetail/viewCourseDetail'),
    method: 'get',
    params: http.params({
      id
    })
  })
}


/**
 * @msg: 添加/修改课件库
 */
export function addCourseWare(data) {
  return http({
    url: http.baseUrl('courseWare/addCourseWare'),
    method: 'post',
    params: http.params(data),
    data: data
  })
}


const add = (url, data) => {
  url = http.baseUrl(url)
  const token = localStorage.getItem('token') || ''
  const instance = axios.create({
    headers: {
      // 'Content-type': 'multipart/form-data',
      'Content-type': 'application/x-www-form-urlencoded',
      Authorization: token,
      Token: token
    },
    withCredentials: true,
    timeout: 1000 * 30
  })
  return instance.post(url, data)
}



/**
 * @msg: 获取办学形式
 */
export function getEducationType() {
  return http({
    url: http.baseUrl('courseWare/getEducationType'),
    method: 'get'
  })
}



/**
 * @msg: 获取基础课程列表
 */
export function getCourseList(params) {
  return http({
    url: http.baseUrl('courseWare/getCourseList'),
    method: 'get',
    params: http.params(params)
  })
}

/**
 * @msg: 搜索课程列表
 */
export function searchCourseList(courseName) {
  return http({
    url: http.baseUrl('courseWare/getCourseList'),
    method: 'get',
    params: http.params({
      courseName
    })
  })
}




/**
 * @msg: 通过uid获取用户
 */
export function getUserByUid(uid) {
  return http({
    url: http.baseUrl('elUser/getUserByUid'),
    method: 'get',
    params: http.params({
      uid
    })
  })
}

/**
 * @msg: 通过uid获取机构
 */
export function getSchoolByUid(uid) {
  return http({
    url: http.baseUrl('elSchool/getSchoolByUid'),
    method: 'get',
    params: http.params({
      uid
    })
  })
}


/**
 * @msg: 下载课件库
 */
export function exportVideoDataList(ids) {
  return http({
    url: http.baseUrl('courseWare/exportVideoDataList'),
    method: 'get',
    params: http.params({
      ids
    })
  })
}
